import { useMutation } from '@tanstack/react-query';
import { CalculatorFormData, payoutEstimate } from '~apis/estimate-calculate';

const useCalculatorForm = () => {
  const payoutEstimationMutation = useMutation({
    mutationKey: ['payoutEstimation'],
    mutationFn: (data: CalculatorFormData) => payoutEstimate(data),
  });

  return {
    payoutEstimationMutation,
  };
};

export default useCalculatorForm;
